import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { BodegaService } from 'src/app/services/bodega.service';
import { FamiliaService } from 'src/app/services/familia.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MovimientoStockService } from 'src/app/services/movimiento-stock.service';
import { RubroService } from 'src/app/services/rubro.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss'],
  providers: [SecurityService],
})
export class ReporteInventarioGeneralComponent implements OnInit {

  // Form
  formHeader: FormGroup

  readonly TIPO_ACTIVO: Number = 10
  readonly TIPO_INACTIVO: Number = 11

  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = "_RB_TIPO_VISTA_RESUMEN_"
  readonly RB_TIPO_VISTA_DETALLE: String = "_RB_TIPO_VISTA_DETALLE_"

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number

  optionsRubro: Array<any> = [];
  optionsBodega: Array<any> = [];
  optionsFamilia: Array<any> = [];

  private resumen_currentPayload: any = null
  resumen_loading: boolean = false
  resumen_listaMovimientos: Array<any> = null
  resumen_listaMovimientosAll: Array<any> = null
  resumen_paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null

  private detalle_currentPayload: any = null
  detalle_loading: boolean = false
  detalle_listaMovimientos: Array<any> = null
  detalle_listaMovimientosAll: Array<any> = null
  detalle_listaMovimientosAllUniq: Array<any> = null
  detalle_paginationContext: PaginationContext = new PaginationContext()
  detalle_totales: any = null

  // Utils
  private log: any
  totalCajas: number = 0;
  groupArr: any;
  costoTotal: number = 0;


  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private bodegaService: BodegaService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private movimientoStockService: MovimientoStockService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private utilsService: UtilsService
  ) {
    this.log = this.clog.log('MOVIMIENTO STOCK')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.resumen_paginationContext.RecordsByPage = 10
    this.detalle_paginationContext.RecordsByPage = 10

    this.createForm()
    this.formChangesSubscriptions()
    this.loadBodegas()
    this.loadRubros()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_DETALLE],
      fecha_movimiento: [this.datesService.CurrentDateToShortTimeString()],
      // `mdb-select` está configurado con [multiple]="true" en el HTML, por lo que
      // este control debe ser un arreglo. Dejarlo vacío significa "todas las bodegas".
      bodega: [[]],
      rubro: [[]],
      familia: [[]],
      mayorCero: [true],
      igualCero: [true],
      incluirInactivo: [false]
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("rubro").valueChanges.subscribe((rubro: string) => {
      this.onRubroSelect(rubro)
    })
  }

  private loadBodegas() {
    this.bodegaService.GetBodegas(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }))
    })
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map(p => ({ value: p.codigo, label: p.descripcion }))
    })
  }

  onRubroSelect(ev) {
    const listaRubros = this.formHeader.get('rubro').value
    this.optionsFamilia = []
    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i])
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubro(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map(p => ({ value: p.codigo, label: p.nombre }))
      this.optionsFamilia = this.optionsFamilia.concat(options)
    })

    // const inputParams = {
    //   entidad: {
    //     rut_emisor: this.rutEmpresa,
    //     sucursal_codigo: this.sucursalCodigo,
    //     fecha_movimiento: this.formHeader.get('fecha_movimiento').value,
    //     sku: '',
    //     filtraSaldo: true,
    //     mayorCero: this.formHeader.get('mayorCero').value === this.TIPO_MAYOR_A_CERO,
    //     producto_activo: null,
    //     listaBodega: this.formHeader.get('bodega').value,
    //     listaRubro: this.formHeader.get('rubro').value,
    //     listaFamilia: this.formHeader.get('familia').value,
    //   },
    //   paginaActual: this.paginationContext.CurrentPage,
    //   cantidadRegistrosPorPagina: -1
    // }
  }

  /********* BÚSQUEDA RESUMEN/DETALLE *********/
  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber)
    this.detalleBuscar(pageNumber)
  }
  /********* BÚSQUEDA RESUMEN/DETALLE *********/

  /********* RESUMEN *********/
  resumenBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.resumen_paginationContext.CurrentPage = pageNumber

    this.resumen_listaMovimientos = null
    this.resumen_listaMovimientosAll = null

    const { fechaDesde, fechaHasta, vendedores, rubros, familias, mayorCero, igualCero, incluirInactivo } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_movimiento: this.formHeader.get('fecha_movimiento').value,
        sku: '',
        mayorCero,
        igualCero,
        producto_activo: incluirInactivo,
        listaBodega: this.formHeader.get('bodega').value,
        listaRubro: this.formHeader.get('rubro').value,
        listaFamilia: this.formHeader.get('familia').value,
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.resumen_paginationContext.RecordsByPage
    }
    this.resumen_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.resumen_loading = true
    this.movimientoStockService.obtenerInventarioGeneralResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.resumen_listaMovimientosAll = registros
      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length //totalRegistros
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage) //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1
      this.resumen_loading = false

      this.showPageResumen(this.resumen_paginationContext.CurrentPage)
      this.calculateTotalesResumen()
    })
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage)
  }

  calculateTotalesResumen() {
    this.resumen_totales = {
      //saldo_total: _.sumBy(this.resumen_listaMovimientosAll, 'saldo'),
      // Importante:
      // En Resumen `listaStockxUnidades` viene desde `stockXUnidadesXBodega` SIN bodega_codigo.
      // Si calculamos cajas con conversión (unidades → cajas) sobre toda la lista,
      // terminamos "armando" cajas con unidades de bodegas distintas, y el total NO cuadra con Detalle.
      // Por eso, para Inventario General Resumen usamos una suma directa:
      // - cajas = sum(cantidad) del formato TOP
      // - unidades = sum(cantidad) de formatos NO TOP (o, si TOP es UNID, unidades = TOP)
      saldo_total: this.calcularSaldoTotalResumenSinCruceBodegas(this.resumen_listaMovimientosAll),
      saldo_total_unidad: this.calcularSaldoTotalUnidadResumenSinCruceBodegas(this.resumen_listaMovimientosAll),
      //costo_total_total: _.sumBy(this.resumen_listaMovimientosAll, 'costo_total')
      costo_total_total: this.calcularTotalTotal(this.resumen_listaMovimientosAll)
      // neto_total: _.sumBy(this.resumen_listaMovimientosAll, 'neto_total')
    }
  }

  resumenOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageResumen(context.RequestedPage)
  }

  resumenDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.resumen_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'
    inputParams.entidad.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.movimientoStockService.obtenerInventarioGeneralResumenExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }
  /********* RESUMEN *********/

  /********* DETALLE *********/
  detalleBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.detalle_paginationContext.CurrentPage = pageNumber

    const { fechaDesde, fechaHasta, vendedores, rubros, familias, mayorCero, igualCero, incluirInactivo } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_movimiento: this.formHeader.get('fecha_movimiento').value,
        sku: '',
        mayorCero,
        igualCero,
        producto_activo: incluirInactivo,
        listaBodega: this.formHeader.get('bodega').value,
        listaRubro: this.formHeader.get('rubro').value,
        listaFamilia: this.formHeader.get('familia').value,
      },
      paginaActual: this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.detalle_paginationContext.RecordsByPage
    }
    this.detalle_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.detalle_loading = true
    this.detalle_listaMovimientos = null
    this.detalle_listaMovimientosAll = null

    this.movimientoStockService.obtenerInventarioGeneralDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.detalle_listaMovimientosAllUniq = _.uniqBy(registros, 'producto_codigo')
      this.detalle_listaMovimientosAll = registros
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage) //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1
      this.showPageDetalle(this.detalle_paginationContext.CurrentPage)
      this.calculateTotalesDetalles()
      this.detalle_loading = false
    })
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage)
  }

  calcularCajas(listado: any, formatoCodigo: string) {
    return this.utilsService.calcularCajas(listado, formatoCodigo);
  }

  calcularUnidades(listado: any, formatoCodigo: string) {
    return this.utilsService.calcularUnidades(listado, formatoCodigo);
  }

  // Versiones que consideran el saldo para el detalle
  calcularCajasConSaldo(listado: any, formatoCodigo: string, saldo: number) {
    return this.utilsService.calcularCajasConSaldo(listado, formatoCodigo, saldo);
  }

  calcularUnidadesConSaldo(listado: any, formatoCodigo: string, saldo: number) {
    return this.utilsService.calcularUnidadesConSaldo(listado, formatoCodigo, saldo);
  }

  calculateTotalesDetalles() {
    this.detalle_totales = {
      saldo_total: this.calcularSaldoTotalXBodega(this.detalle_listaMovimientosAll),
      // Detalle: 1 fila por (sku, bodega). Caja y Unidad en columnas separadas. Sumar fraccion por fila.
      // Compatibilidad TS (sin ?. ni ??)
      saldo_total_unidad: _.sumBy(this.detalle_listaMovimientosAll, (x: any) => (x && x.fraccion != null ? Number(x.fraccion) : 0)),
      costo_total_total: this.calcularTotalCostoFormatoPrincipalXBodega(this.detalle_listaMovimientosAll)
      //saldo_total: _.sumBy(this.detalle_listaMovimientosAll, 'saldo'),
      //costo_total_total: _.sumBy(this.detalle_listaMovimientosAll, 'costo_total')
    }
  }

  detalleOnPageChange(context: PaginationContext) {
    // this.detalleBuscar(context.RequestedPage)
    this.showPageDetalle(context.RequestedPage)
  }

  detalleDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.detalle_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'
    inputParams.entidad.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.movimientoStockService.obtenerInventarioGeneralDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  obtenerCantidadFormato(listado: any, formatoCodigo: string) {
    return this.utilsService.obtenerCantidadFormato(listado, formatoCodigo);
  }

  obtenerFormatoPrincipal(listado: any) {
    return this.utilsService.obtenerFormatoPrincipal(listado);
  }

  obtenerFormatoSecundario(listado: any) {
    return this.utilsService.obtenerFormatoSecundario(listado);
  }

  calcularStockFormatoPrincipal(listado: any) {
    return this.utilsService.calcularStockFormatoPrincipal(listado);
  }

  calcularStockFormatoSecundario(listado: any) {
    return this.utilsService.calcularStockFormatoSecundario(listado);
  }

  // Versiones que consideran el saldo para el resumen
  calcularStockFormatoPrincipalConSaldo(listado: any, saldo: number) {
    return this.utilsService.calcularStockFormatoPrincipalConSaldo(listado, saldo);
  }

  calcularStockFormatoSecundarioConSaldo(listado: any, saldo: number) {
    return this.utilsService.calcularStockFormatoSecundarioConSaldo(listado, saldo);
  }

  // Inventario General (Resumen):
  // Calcular sin convertir unidades→cajas entre bodegas. UNID y MED (Media) van a columna Unidad.
  private esFormatoUnidadOFraccion(top: string): boolean {
    if (!top) return false;
    const t = top.toLowerCase();
    return t.includes('unid') || t.includes('med');
  }

  calcularCajasResumenSinCruceBodegas(listado: any) {
    if (!listado || listado.length === 0) {
      return 0;
    }
    const first = listado[0];
    if (!first) {
      return 0;
    }
    
    // Caso especial: Si formato_codigo es UNID pero nombre_formato es CA, tratarlo como caja
    if (first.formato_codigo && String(first.formato_codigo).toLowerCase() === 'unid' &&
        first.nombre_formato && String(first.nombre_formato).toUpperCase() === 'CA') {
      let total = 0;
      for (let i = 0; i < listado.length; i++) {
        const it = listado[i];
        if (it && it.formato_codigo != null && it.formato_codigo_top != null && it.formato_codigo === it.formato_codigo_top) {
          total += Number(it.cantidad || 0);
        }
      }
      return total;
    }
    
    const top = first.formato_codigo_top ? String(first.formato_codigo_top) : '';
    if (this.esFormatoUnidadOFraccion(top)) {
      return 0;
    }
    let total = 0;
    for (let i = 0; i < listado.length; i++) {
      const it = listado[i];
      if (it && it.formato_codigo != null && it.formato_codigo_top != null && it.formato_codigo === it.formato_codigo_top) {
        total += Number(it.cantidad || 0);
      }
    }
    return total;
  }

  calcularUnidadesResumenSinCruceBodegas(listado: any) {
    if (!listado || listado.length === 0) {
      return 0;
    }
    const first = listado[0];
    if (!first) {
      return 0;
    }
    
    // Caso especial: Si formato_codigo es UNID pero nombre_formato es CA, tratarlo como caja (unidades = 0)
    if (first.formato_codigo && String(first.formato_codigo).toLowerCase() === 'unid' &&
        first.nombre_formato && String(first.nombre_formato).toUpperCase() === 'CA') {
      return 0;
    }
    
    const top = first.formato_codigo_top ? String(first.formato_codigo_top) : '';
    // Si el top es UNID o MED (Media), el stock va a columna Unidad.
    if (this.esFormatoUnidadOFraccion(top)) {
      let totalTop = 0;
      for (let i = 0; i < listado.length; i++) {
        const it = listado[i];
        if (it && it.formato_codigo != null && it.formato_codigo_top != null && it.formato_codigo === it.formato_codigo_top) {
          totalTop += Number(it.cantidad || 0);
        }
      }
      return totalTop;
    }
    // Caso normal: unidades = formatos distintos del top
    let total = 0;
    for (let i = 0; i < listado.length; i++) {
      const it = listado[i];
      if (it && it.formato_codigo != null && it.formato_codigo_top != null && it.formato_codigo !== it.formato_codigo_top) {
        total += Number(it.cantidad || 0);
      }
    }
    return total;
  }

  calcularSaldoTotalResumenSinCruceBodegas(registros: any) {
    if (!registros || registros.length === 0) return 0;
    let total = 0;
    for (let i = 0; i < registros.length; i++) {
      const it = registros[i];
      total += this.calcularCajasResumenSinCruceBodegas(it ? it.listaStockxUnidades : null);
    }
    return total;
  }

  calcularSaldoTotalUnidadResumenSinCruceBodegas(registros: any) {
    if (!registros || registros.length === 0) return 0;
    let total = 0;
    for (let i = 0; i < registros.length; i++) {
      const it = registros[i];
      total += this.calcularUnidadesResumenSinCruceBodegas(it ? it.listaStockxUnidades : null);
    }
    return total;
  }

  calcularSaldoTotal(registros: any) {
    return this.utilsService.calcularSaldoTotal(registros);
  };

  calcularSaldoTotalUnidad(registros: any) {
    return this.utilsService.calcularSaldoTotalUnidad(registros);
  };

  calcularTotalTotal(registros: any) {
    return this.utilsService.calcularTotalTotal(registros);
  };
  calcularSaldoTotalXBodega(registros: any) {
    return this.utilsService.calcularSaldoTotalXBodega(registros);
  };

  calcularSaldoTotalUnidadXBodega(registros: any) {
    return this.utilsService.calcularSaldoTotalXBodegaUnidad(registros);
  };

  calcularTotalCostoFormatoPrincipalXBodega(registros: any) {
    return this.utilsService.calcularTotalCostoFormatoPrincipalXBodega(registros);
  };

  calcularCostoTodosLosFormatos(listado: any, costo_formato_principal: number) {
    return this.utilsService.calcularCostoTodosLosFormatos(listado, costo_formato_principal);
  };
  calcularCostoTodosLosFormatosSegunFormato(listado: any, formato_codigo: string, producto_codigo: string) {
    const costoTotalFormatoPrincipal = this.utilsService.obtenerPrecioCostoFormatoPrincipal(this.detalle_listaMovimientosAllUniq, formato_codigo, producto_codigo);

    return this.utilsService.calcularCostoTodosLosFormatosSegunFormato(listado, costoTotalFormatoPrincipal, formato_codigo);
  }

  // calcularCostoSegunFormato(listado: any, costo_formato_principal: number, formato_codigo: string) {
  //   return this.utilsService.calcularCostoSegunFormato(listado, costo_formato_principal, formato_codigo);
  // }

}
